/**
 * Detail bundle for a single `:SafetyPoint` (`$pointId` param).
 *
 * Returns:
 *   - `point`      — the node itself
 *   - `diagram`    — owning `(:FunctionLogicDiagram)-[:CONTAINS]->`
 *   - `solver`     — FLD's `(:LogicSolver)-[:CONTAINS]->`
 *   - `site`       — solver `[:PART_OF]->(:Site)`
 *   - `functions`  — `(:ProtectiveFunction)-[:IMPLEMENTED_BY]->` this point
 *   - `equipment`  — `(:Equipment)-[:MAPS_TO_SAFETY_POINT]->` this point
 *
 * Bounded by `LIMIT 1`. Related lists are collected.
 */
export const PLANT_SAFETY_POINT_DETAIL_CYPHER = `
            MATCH (sp:SafetyPoint {id: $pointId})
            OPTIONAL MATCH (fld:FunctionLogicDiagram)-[:CONTAINS]->(sp)
            OPTIONAL MATCH (ls:LogicSolver)-[:CONTAINS]->(fld)
            OPTIONAL MATCH (ls)-[:PART_OF]->(site:Site)
            OPTIONAL MATCH (pf:ProtectiveFunction)-[:IMPLEMENTED_BY]->(sp)
            OPTIONAL MATCH (eq:Equipment)-[:MAPS_TO_SAFETY_POINT]->(sp)
            RETURN sp AS point,
                   fld AS diagram,
                   ls AS solver,
                   site,
                   collect(distinct pf) AS functions,
                   collect(distinct eq) AS equipment
            LIMIT 1
          `
